import Vue from 'vue'
import {Autocomplete, Button, Descriptions, DescriptionsItem, Empty, Input, Option, Select} from 'element-ui'

Vue.use(Button)
Vue.use(Autocomplete)
Vue.use(Select)
Vue.use(Option)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Empty)
Vue.use(Input)

